<template>
  <div class="my-8 bg-primary-50 px-4 py-6 md:py-8 lg:py-10 xl:py-12">
    <div class="max-w-5xl mx-auto">
      <div>
        <GeneralHorizontalScrollSection>
          <template #header>
            <THeading
              :level="3"
              tag="h2"
            >
              {{ title }}
            </THeading>
          </template>
          <div
            v-for="review in reviews"
            :key="review.ReviewId"
            class="w-80 lg:w-[calc((100%_-_2rem)/3)] flex-shrink-0 snap-start"
          >
            <RvRentalsReviewCard :review="review" />
          </div>
        </GeneralHorizontalScrollSection>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { DestinationTripReview } from '~/types'

const props = defineProps<{
  rvTitle: string
  locationTitle: string
  locationName: string
  reviews: DestinationTripReview[]
  keepCurrentSeoContent?: boolean
  avgRating?: number
  reviewCount?: number
}>()

const { t } = useI18n()

const title = computed(() => {
  const hasReviewStats = Boolean(props.avgRating) && Boolean(props.reviewCount)
  if (props.keepCurrentSeoContent || !hasReviewStats) {
    return t('title', { rvTitle: props.rvTitle, locationName: props.locationName, locationTitle: props.locationTitle })
  }

  return t('titleDestination', { locationName: props.locationName, avgRating: props.avgRating, reviewCount: props.reviewCount })
})
</script>

<i18n lang="json">
{
  "en": {
    "title": "Recent {locationName} {rvTitle} rental reviews",
    "titleDestination": "{locationName} RV rental reviews - {avgRating} out of 5 from {reviewCount} renters"
  },
  "fr": {
    "title": "Récents avis sur la location de {rvTitle} {locationTitle}",
    "titleDestination": "{locationName} avis sur la location de VR - {avgRating} sur 5 de {reviewCount} invités"
  }
}
</i18n>
